<template>
    <div class="card-pay-container" v-wechat-title="'mysread'">

        <!--頂部欄-->
        <div class="top-nav-container" style="position: fixed;top: 0;">
            <span class="title-style">充值</span>
            <span @click="backClick" style="position: absolute;left: 10px">返回</span>
        </div>

        <div style="margin-top: 70px">
            <div id="cz_form"></div>
        </div>
        <div id="ajax_div"></div>

    </div>
</template>

<script>
export default {
    name: "CardPayVue",
    data() {
        return {
            userId: "",
            htmlText: "",
            fromVueName: "",
            bookId: "",
            bookName: "",
            chapterId: "",
        };
    },
    methods: {
        //返回
        backClick: function () {
            if (this.fromVueName === "ChapterDetailVue") {
                this.$router.push({
                    path: "ChapterDetailVue",
                    query: {
                        bookId: this.bookId,
                        chapterId: this.chapterId,
                    },
                });
            } else {
                this.$router.push({
                    path: "MineVue",
                });
            }
        },

        //展示支付界面
        showPayHtml: function () {
            const requestUrl =
                "https://b.mysread.com/h5_api.php?ac=get_cz_form&app_user_id=" +
                this.userId;
            this.$http.get(requestUrl).then((res) => {
                if (res.status === 200) {
                    let newStr = res.data.replace(
                        new RegExp("/images/", "gm"),
                        "https://b.mysread.com/images/"
                    );
                    newStr = newStr.replace(
                        new RegExp("/upload/", "gm"),
                        "https://b.mysread.com/upload/"
                    );
                    $("#cz_form").html(newStr);
                }
            });
        },
    },

    created() {
        this.userId = localStorage.getItem("userId");
        this.fromVueName = this.$route.query.vueName;
        this.bookId = this.$route.query.bookId;
        this.chapterId = this.$route.query.chapterId;
        this.showPayHtml();
    },

    mounted() {
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }

        gtag("js", new Date());
        gtag("config", "AW-863726682");

        //Event snippet for 開始結帳
        gtag("event", "conversion", {
            send_to: "AW-863726682/gizBCO-2k-wBENrY7ZsD",
        });
        console.log(
            "google 像素 進入 充值界面: 'AW-863726682/gizBCO-2k-wBENrY7ZsD"
        );
    },
};
</script>

<style scoped>
.card-pay-container {
    max-width: 480px;
    height: 100%;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/CardPayVue.vue